export enum Role {
  COOLING = 'COOLING',
  HEATING = 'HEATING'
}
